// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2218":"4b279159","9565":"a4ab9606"}[chunkId] || chunkId) + "." + {"2218":"9d46269f84dc2cd9","3675":"fbdc0528f3e31686","3848":"3539591b05f217ec","6435":"596409ae313d242e","8805":"677a1bb42c0d72b5","9565":"e38a3b7f3d5497f3"}[chunkId] + ".js";
};